module.exports = __webpack_public_path__ + "img/d256ae44beca3a2bf8e09cec1b5a4aaf.529dff70.png";